



















































































import { Vue, Component, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import { collections } from "@/configs/firebase";
import { User } from "@/types";
import { objectify } from "../helpers";
import moment from "moment";

@Component
export default class LeaderBoard extends Vue {
  @State("user") user!: User;

  topclosers: any = null;
  otherClosers: any = null;
  closers: any = null;
  agents: any[] = [];
  agentRank: number = -1;

  unsubscribe!: Function;

  @Watch("agents")
  onAgentsChange() {
    this.rankAgents();
  }

  get dateToday() {
    return moment().format("MMM DD, YYYY");
  }

  get isAdmin() {
    return this.user.roles && this.user.roles.includes("admin");
  }

  get leaderBoardHeader() {
    return `You're rank ${this.agentRank}!`;
  }

  agentLeaderboardIndex(agentId: string) {
    return this.closers.findIndex((agent: any) => agent.id === agentId) + 1;
  }

  userRowHiglight(agentEmail: string) {
    return this.userEmail === agentEmail ? { backgroundColor: "#E3E8EC" } : {};
  }

  getIndexStyle(index: number) {
    switch (index) {
      case 1:
        return {
          color: "#165A6C"
        };
      case 2:
        return {
          color: "#294F72"
        };
      case 3:
        return {
          color: "#F4C172"
        };
      default:
        return {
          color: "#D2DADC"
        };
    }
  }

  get closerAgents() {
    /**
     * return this.agents.filter(
      agent => agent.groups && agent.groups.includes("fronter_t1")
    );
     */
    return this.agents;
  }

  get userEmail() {
    return this.user.email;
  }

  mounted() {
    this.unsubscribe = collections.user
      .where("roles", "array-contains", "closer")
      .onSnapshot(snapshot => {
        this.agents = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
      });
  }

  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  rankAgents() {
    const preData = this.closerAgents.reduce((arry, agent) => {
      const name =
        this.userEmail === agent.email
          ? agent.email.split("@")[0]
          : agent.email.substring(0, 3).toUpperCase();

      const stats = objectify(agent.weekly_stats);

      arry.push({
        id: agent.id,
        name: name.charAt(0).toUpperCase() + name.slice(1),
        agentScore: Math.round(agent.ranking_score * 100) / 100,
        ancillaries: stats.ancillaries,
        premiums: Math.round(stats.premiums),
        sales: stats.sales,
        email: agent.email
      });

      return arry;
    }, []);

    const ranking = preData.sort(
      (a: any, b: any) => b.agentScore - a.agentScore
    );

    const agentRankIndex = ranking.findIndex(
      (agent: any) => this.userEmail === agent.email
    );

    this.agentRank = agentRankIndex + 1;
    this.closers = ranking;
    this.topclosers = ranking.slice(0, 3);
    if (ranking.length > 3) {
      this.otherClosers = ranking.slice(3);
    }
  }
}
